module.exports = __webpack_public_path__ + "static/media/form-saude-mobal.2f895fac.png";